import { observer } from "mobx-react";
import { IValidationGroup } from "../../../../../../../hooks/validation-group/validation-group-hook";
import { FormFieldLine } from "../../../../../../../components/form-field-line/form-field-line";
import { Input } from "../../../../../../../components/inputs/input/input";
import SalasaCredentialsStore from "../../../../stores/credentials/shipping/salasa-credentials-store";

interface IProps {
    credentialsStore: SalasaCredentialsStore,
    vGroup: IValidationGroup,
}

const SalasaCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    return (
        <>
            <FormFieldLine
                required
                label='Salasa Account ID'
                key='account_id'
                note='Your Salasa Account Number'
            >
                <Input
                    value={credentialsStore.accountId}
                    onChange={credentialsStore.setAccountId}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Salasa Warehouse'
                key='warehouse'
                note='Your Salasa Warehouse'
            >
                <Input
                    value={credentialsStore.warehouse}
                    onChange={credentialsStore.setWarehouse}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            {
                // EXPLANATION WHY LABEL AND KEY ARE REVERSED (key=api_token, but label is Api Key)
                // Salasa integration was deployed and was working without the UI connection part
                // there is a mistake in the shipping api, we provide apiKey as apiToken and vice verse for Salasa request auth
                // As Salasa UI connection is developed later, we cant change the logic on Shipping api
                // and we should take it in consideration in rms client, and do not mislead a merchant
            }
            <FormFieldLine
                required
                label='Salasa Api Key'
                key='api_token'
                note='Your Salasa Api Key (long value)'
            >
                <Input
                    value={credentialsStore.apiToken}
                    onChange={credentialsStore.setApiToken}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Salasa Api Token'
                key='api_key'
                note='Your Salasa Api Token (short value)'
            >
                <Input
                    value={credentialsStore.apiKey}
                    onChange={credentialsStore.setApiKey}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default SalasaCredentials;
